import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { CartDrawer } from "@/components/CartDrawer";
import { SplitkartLogo } from "@/components/SplitkartLogo";
import { SHOPIFY_APP_STORE_URL } from "@/lib/appLinks";

const cartEnabledRoutes = ["/product/"];

const navLinks = [
  { label: "How it Works", href: "/how-it-works" },
  { label: "Pricing", href: "/pricing" },
  { label: "Blog", href: "/blog" },
];

export function Header() {
  const location = useLocation();
  const showCarts = cartEnabledRoutes.some((route) => location.pathname.startsWith(route));
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all ${
        scrolled
          ? "border-b border-border bg-background/85 backdrop-blur-md"
          : "border-b border-transparent bg-background"
      }`}
    >
      <div className="container-tight flex h-16 items-center justify-between">
        <a href="/" className="shrink-0">
          <SplitkartLogo className="origin-left scale-[0.82] sm:scale-90 md:scale-100" />
        </a>

        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          {showCarts && <CartDrawer />}

          <Button asChild variant="ghost" className="hidden h-10 rounded-lg px-4 text-sm font-semibold md:inline-flex">
            <Link to="/merchant-login">Login</Link>
          </Button>

          <Button asChild className="hidden h-10 rounded-lg px-4 text-sm font-semibold md:inline-flex">
            <a href={SHOPIFY_APP_STORE_URL} target="_blank" rel="noreferrer">Add to Shopify</a>
          </Button>

          <button className="md:hidden" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-border bg-background md:hidden">
          <div className="container-tight space-y-1 py-4">
            {navLinks.map((link) => (
              <Link key={link.href} to={link.href} className="block rounded-md px-3 py-2 text-sm font-medium hover:bg-accent">
                {link.label}
              </Link>
            ))}
            <Link to="/merchant-login" className="block rounded-md px-3 py-2 text-sm font-medium hover:bg-accent">
              Login
            </Link>
            <a href={SHOPIFY_APP_STORE_URL} target="_blank" rel="noreferrer" className="mt-2 block rounded-lg bg-primary px-4 py-2.5 text-center text-sm font-semibold text-primary-foreground">
              Add to Shopify
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
